import React from 'react';
import { CompiledAdvancedDailyEngagedUsersContainer } from '../styles';
import CompiledAdvancedDailyEngagedUsers from './CompiledAdvancedDailyEngagedUsers';
import AdvancedDailyEngagedUserMonthlyUsage from './AdvancedDailyEngagedUserMonthlyUsage';
import AdvancedDailyEngagedUserDailyUsage from './AdvancedDailyEngagedUserUsage';

const AdvancedDailyEngagedUsersSummary: React.FC = () => {
  return (
    <CompiledAdvancedDailyEngagedUsersContainer>
      <CompiledAdvancedDailyEngagedUsers />
      <AdvancedDailyEngagedUserMonthlyUsage />
      <AdvancedDailyEngagedUserDailyUsage />
    </CompiledAdvancedDailyEngagedUsersContainer>
  );
};

export default AdvancedDailyEngagedUsersSummary;